import {FieldSize} from "../service/EditorService";
import {action, makeAutoObservable} from "mobx"
import {urls} from "../ApiUtils";
import {DrillPoint, EditorModeType} from "../service/Editor";

type GCodeParameters = {
    plateThickness: number
}

class FileEditorStore {
    fileContent: string = ""
    drillData: Array<DrillPoint> = []
    selectedFileName: string = ""
    fieldSize: FieldSize = {width: 0.0, height: 0.0}
    isActive: boolean = false
    zeroOffsetX: number = 0.0
    zeroOffsetY: number = 0.0
    currentMode: EditorModeType = EditorModeType.ROUTES
    slidePanelExpanded: boolean = false

    constructor() {
        makeAutoObservable(this)
    }

    loadFileContent(selectedFileName: string) {
        if (selectedFileName == null) {
            this.setActive(false)
            return
        }
        if (this.selectedFileName !== selectedFileName) {
            const targetEditorGenerate = urls.apiV1.editor.generate(selectedFileName)
            fetch(targetEditorGenerate.url, {
                method: targetEditorGenerate.method
            }).then((v) => {
                return v.json()
            }).then((loadedFileData) => {
                this.updateState(loadedFileData)
            });
        } else {
            this.setActive(true)
        }
    }

    getSlidePanelExpanded(): boolean {
        return this.slidePanelExpanded
    }

    @action
    setZeroOffsetX(zeroOffsetX: number) {
        this.zeroOffsetX = zeroOffsetX
    }

    @action
    setZeroOffsetY(zeroOffsetY: number) {
        this.zeroOffsetY = zeroOffsetY
    }

    @action
    setMode(mode: EditorModeType) {
        this.currentMode = mode
    }

    @action
    toggleSlidePanelExpanded() {
        this.slidePanelExpanded = !this.slidePanelExpanded
    }

    @action
    private setActive(isActive: boolean) {
        this.isActive = isActive
        this.slidePanelExpanded = false
        // this.slidePanelExpanded = this.slidePanelExpanded && this.isActive
    }

    @action
    private updateState(state: any) {
        this.zeroOffsetX = +state.leftTopDrill.point.x
        this.zeroOffsetY = +state.leftTopDrill.point.y
        this.fieldSize = state.fieldSize
        this.selectedFileName = state.name
        this.fileContent = state.metaContent
        this.drillData = state.drillData
        this.setActive(true)
    }
}

export const fileEditorStore: FileEditorStore = new FileEditorStore()
